export class UserGroup {
  id: string;
  name: string;
}
